export { TrackEventTypes } from '@/entities/tracking/const';

const SANDBOX = 'sandbox';
const ROUTE_CHANGE_COMPLETE = 'routeChangeComplete';
const ROUTE_CHANGE_ERROR = 'routeChangeError';
const ROUTE_CHANGE_START = 'routeChangeStart';
const UPDATE_DATA_LAYER = 'updateDataLayer';

const PAGE_UPDATE = 'pageUpdate';
const EVENT = 'event';
const ERROR = 'error';
const DATA_TAG = 'data-';

const PROGRAMMATIC = 'programmatic';
const PAID_SEARCH = 'paid-search';
const DIRECT = 'direct';

export enum TRACK_LINK_NAMES {
    ADD_PROFILE = 'trackAddUserProfile',
    AGE_RESTRICTION_HOME = 'trackHomeAgeRestriction',
    AGE_RESTRICTION_SWITCH = 'trackSwitchProfilesAgeRestriction',
    CONFIRM_PASSWORD_CONTINUE = 'trackEnterPassword',
    CONFIRM_PASSWORD_SUCCESS = 'trackContinueConfirmAccount',
    CREATE_PIN = 'trackCreatePin',
    CREATE_PIN_CANCEL = 'trackCancelPin',
    CREATE_PIN_SAVE = 'trackSavePinSuccess',
    CREATE_PROFILE_CANCEL = 'trackUserProfileCancel',
    CREATE_PROFILE_SAVE = 'trackProfileCreated',
    DELETE_PROFILE_CANCEL = 'trackKeepUserProfile',
    DELETE_PROFILE_SAVE = 'trackProfileDelete',
    ENTER_PIN_ENTER = 'trackParentalControlsPromptView',
    ENTER_PIN_FAIL = 'trackParentalControlsEnterPinFail',
    ENTER_PIN_SUCCESS = 'trackParentalControlsEnterPinOk',
    PARENTAL_CONTROLS_ENTER_PIN_OK = 'trackparentalcontrolsenterpinok',
    PARENTAL_CONTROLS_ENTER_PIN_FAIL = 'trackparentalcontrolsenterpinfail',
    PARENTAL_CONTROLS_ENTER_PIN_FORGET_PIN = 'trackparentalcontrolsenterpinforgetpin',
    FOOTER = 'trackFooter',
    FORGOT_PIN = 'trackForgotPIN',
    GENRE_TAB_SELECTED = 'trackShowPickerGenreSelect',
    MANAGE_EDIT_PROFILE = 'trackEditUserProfile',
    MANAGE_PROFILES_DONE = 'trackFinishedManageProfiles',
    NAV = 'trackNav',
    NAV_DROPDOWN = 'trackNavDropdown',
    PROFILE_EDIT = 'trackProfileEdited',
    PROFILE_EDIT_DELETE = 'trackEditProfileDelete',
    SELECT_AVATAR = 'trackAvatarSelect',
    SHOWPICKER_SELECT = 'trackShowPickerSelection',
    SIGN_OUT_ALL_DEVICES_CANCEL = 'trackSignOutAllDevicesCancelCTA',
    SIGN_OUT_ALL_DEVICES_CONFIRM = 'trackSignOutAllDevicesConfirmCTA',
    SIGN_OUT_ALL_DEVICES_EMAIL_SENT = 'trackEmailSentToSignOutAllDevices',
    SIGN_OUT_ALL_DEVICES_REQUEST = 'trackRequestNewLink',
    SIGN_OUT_ALL_DEVICES_SUCCESS = 'trackSignOutAllDevicesSuccess',
    TRACK_APP_LOG = 'trackapplog',
    TRACK_PARTNER_BIND_SUCCESS = 'oAuthTrackPaymentComplete',
    TRACK_FAQ_CLICK = 'trackFAQClick',
    TRACK_FORGOT_PASSWORD = 'trackForgotPassword',
    TRACK_FORGOT_PASSWORD_LOWERCASED = 'trackforgotpassword',
    TRACK_EDIT_PASSWORD = 'trackEditPassword',
    TRACK_EDIT_PASSWORD_LINK_SENT_VIEW = 'trackEditPasswordLinkSentView',
    TRACK_RESET_PASSWORD = 'trackresetpassword',
    TRACK_RESET_PASSWORD_SUCCESS = 'trackResetPasswordSuccess',
    TRACK_GET_OFFER = 'trackGetOffer',
    TRACK_HIDE_PASSWORD = 'trackHidePassword',
    TRACK_LIVE_TV_DRAWER_FAVORITE_CHANNEL = 'trackLiveTvDrawerFavoriteChannel',
    TRACK_LIVE_TV_DRAWER_UNFAVORITE_CHANNEL = 'trackLiveTvDrawerUnfavoriteChannel',
    TRACK_LIVE_TV_DRAWER_INFO = 'trackLiveTvDrawerInfo',
    TRACK_LIVE_TV_GUIDE_ADD_TO_MY_LIST = 'trackLiveTvGuideAddToMyList',
    TRACK_LIVE_TV_GUIDE_REMOVE_FROM_MY_LIST = 'trackLiveTvGuideRemoveFromMyList',
    TRACK_LIVE_TV_GUIDE_DRAWER = 'trackLiveTvGuideDrawer',
    TRACK_LIVE_TV_GUIDE_DRAWER_CLOSE = 'trackLiveTvGuideDrawerClose',
    TRACK_LIVE_TV_GUIDE_DRAWER_RESTART = 'trackLiveTvGuideDrawerRestart',
    TRACK_LIVE_TV_GUIDE_DRAWER_WATCH_NOW = 'trackLiveTvGuideDrawerWatchNow',
    TRACK_LIVE_TV_GUIDE_INFO = 'trackLiveTvGuideInfo',
    TRACK_LIVE_TV_DETAILS_FAVORITE_CHANNEL = 'trackFavoriteChannelSelect',
    TRACK_LIVE_TV_DETAILS_UNFAVORITE_CHANNEL = 'trackUnfavoriteChannelSelect',
    TRACK_DRAWER_WATCH_LIVE_CHANNEL = 'trackDrawerWatchLiveChannel',
    TRACK_CHANNEL_BROWSE_CATEGORY_SELECT = 'trackChannelBrowseCategorySelect',
    TRACK_JUMP_TO_CHANNEL_SELECT = 'trackJumpToChannelSelect',
    TRACK_NETWORK_SELECT = 'trackNetworkSelection',
    TRACK_LOGIN = 'trackLogin',
    TRACK_LOGIN_SUCCESS = 'trackLoginSuccess',
    TRACK_CANCEL_OFFER_REDEMPTION_SUCCESS = 'trackCancelOfferRedemptionSuccess',
    TRACK_MENU = 'trackMenu',
    TRACK_MVPD_ACTIVATION_SUCCESS = 'trackMVPDActivationSuccess',
    TRACK_PICK_PLAN_SELECTION = 'trackPickPlanSelection',
    TRACK_PICK_PLAN_TOGGLE = 'trackPickPlanToggle',
    TRACK_ROW_HEADER = 'trackRowHeader',
    TRACK_SHOW_PASSWORD = 'trackShowPassword',
    TRACK_SIGNIN_TV_PROVIDER = 'trackSignInTvProvider',
    TRACK_UPSELL_GET_SHOWTIME_BUNDLE = 'trackUpsellGetShowtimeBundle',
    TRACK_UPSELL_LINK_TV_PROVIDER_SELECT = 'trackUpsellLinkTvProviderSelect',
    TRACK_UPSELL_ROW_HEADER = 'trackUpsellRowHeader',
    TRACK_UPSELL_ROW_HEADER_CTA = 'trackUpsellRowHeaderCTA',
    TRACK_UPSELL_ROW_HEADER_TOTAL = 'trackUpsellRowHeaderTotal',
    WHOS_WATCHING_PROFILE_CLICK = 'trackProfileSelection',
    TRACK_BACK_TO_ACCOUNT_CTA = 'trackBackToAccountCTA',
    TRACK_CANCEL_SUBSCRIPTION_SUCCESS = 'trackCancelSubscriptionSuccess',
    TRACK_CONTINUE_TO_CANCEL_CTA = 'trackContinueToCancelCTA',
    TRACK_REDFAST_REDEEM_OFFER_MODAL = 'trackRedfastRedeemOfferModal',
    TRACK_ACCOUNT_BANNER_DISPLAY = 'trackAccountBannerDisplay',
    TRACK_CONFIRM_ACCOUNT_CONTINUE_SELECT = 'trackConfirmAccountContinueSelect',
    TRACK_SWITCH_ACCOUNT_SELECT = 'trackSwitchAccountSelect',
    TRACK_SIGNOUT = 'trackSignOut',
    TRACK_CANCEL_SIGNOUT_SELECT = 'trackCancelSignOutSelect',
    TRACK_ACTIVATION = 'trackactivation',
    TRACK_DEEPLINK = 'trackdeeplink',
    TRACK_EMAIL_CHECKPOINT_NEXT_SELECT = 'trackEmailCheckpointNextSelect',
    TRACK_AGREE_AND_CONTINUE_SELECT = 'trackagreeandcontinueselect',
    TRACK_SIGNIN_CHANGE_EMAIL_SELECT = 'trackSigninChangeEmailSelect',
    TRACK_SIGNUP_CHANGE_EMAIL_SELECT = 'tracksignupchangeemailselect',
    TRACK_FORGOT_PASSWORD_OK_SELECT = 'trackforgotpasswordokselect',
    TRACK_REGISTRATION_NEW = 'trackregistrationnew',
    TRACK_BACK_SELECT = 'trackbackselect',
    TRACK_FAQ = 'trackfaq',
    TRACK_SIGN_OUT = 'tracksignout',
    TRACK_EDIT_EMAIL = 'trackeditemail',
    TRACK_EDIT_EMAIL_LINK_SENT_VIEW = 'trackeditemaillinksentview',
    TRACK_EDIT_EMAIL_SUCCESS = 'trackeditemailsuccess',
    TRACK_CONFIRM_EMAIL_EDIT_SELECT = 'trackconfirmemaileditselect',
    TRACK_MARKETING_CHECKBOX_SELECT = 'trackmarketingcheckboxselect',
    TRACK_MARKETING_CHECKBOX_DESELECT = 'trackmarketingcheckboxdeselect',
    TRACK_MARKETING_COMS_SUBSCRIBE_VIEW = 'trackmarketingcomssubscribeview',
    TRACK_MARKETING_COMS_UNSUBSCRIBE_VIEW = 'trackmarketingcomsunsubscribeview',
    TRACK_CANCEL = 'trackcancel',
    TRACK_PASSWORD_PARENTAL_CONTROL_SUBMIT = 'trackpasswordparentalcontrolsubmit',
    TRACK_PARENTAL_CONTROL_ON = 'trackparentalcontrolon',
    TRACK_EDIT_PARENTAL_CONTROLS_OFF = 'trackeditparentalcontrolsoff',
    TRACK_PARENTAL_CONTROLS_CANCEL = 'trackparentalcontrolscancel',
    TRACK_EDIT_PARENTAL_CONTROLS = 'trackeditparentalcontrols',
    TRACK_ALWAYS_ON_PLAYER_ENABLED = 'trackalwaysonplayerenabled',
    TRACK_ALWAYS_ON_PLAYER_DISABLED = 'trackalwaysonplayerdisabled',
    TRACK_ALWAYS_ON_PLAYER_JUMP_TO_VIDEO_SELECT = 'trackalwaysonplayerjumptovideoselect',
}

const FOOTER = 'footer';
const NAV = 'nav';

enum PAGE_TYPES {
    EDIT = 'profile_edit',
    WHOS_WATCHING = 'profile_who_is_watching',
    MANAGE = 'profile_manage',
    CREATE = 'profile_create',
    DELETE = 'profile_delete',
    AGE_RESTRICTION = 'parental_control_pin',
    SELECT_AVATAR = 'select_avatar',
    SHOWPICKER = 'showpicker',
    COMPILING = 'compiling',
    CREATE_PIN = 'kids_pin_creation',
    ENTER_PIN = 'enter_pin',
    CONFIRM_PASSWORD = 'confirm-password',
    TV_PROVIDER_ACTIVATION = 'tv-provider_activation',
    TV_PROVIDER_CONNECT = 'tv-provider_connect',
    TV_PROVIDER_SUCCESS = 'tv-provider_success',
    SIGN_IN = 'svod_signin',
    SIGN_UP = 'svod_signup',
    BIND_FAILURE = 'svod_bindingFailure',
    UPSELL = 'svod_upsell',
    FORGOT_PASSWORD = 'svod_forgotpassword',
    CHANGE_PASSWORD = 'svod_changepassword',
    CHANGE_EMAIL = 'svod_changeemail',
    ACCOUNT = 'account',
    SVOD_ACCOUNT = 'svod_account',
    SWITCH_PAYMENT = 'account_switchpayment',
    EMAIL_CHECKPOINT = 'emailcheckpoint',
    CANCEL_SUBSCRIPTION_INTERMEDIATE = 'cancel_subscription_intermediate',
    RENDEZVOUS_ACTIVATION_CODE = 'rendezvous_activation_code',
    RENDEZVOUS_ACTIVATION_ENTER_CODE = 'rendezvous_activation_enter_code',
    RENDEZVOUS_ACTIVATION_COMPLETE = 'rendezvous_activation_complete',
    RENDEZVOUS_ACTIVATION_SIGNIN = 'rendezvous_activation_signin',
    REDEEM_CANCEL_OFFER = 'redeem_cancel_offer',
    WEB_ACTIVATION_ENTER_EMAIL = 'webactivationenteremail',
    WEB_DEVICE_ACTIVATION_CONFIRM_SIGNOUT = 'webdeviceactivationconfirmsignout',
    DEEPLINK = 'deep-link',
    SHOW = 'show',
    SHOW_DETAILS = 'show-details',
    MOVIE = 'movie',
    MOVIE_DETAILS = 'movie-details',
    LIVE_TV_GUIDE = 'live-tv-guide',
    CHANNEL_DETAILS = 'channel-details',
}

enum APP_LOG_TYPE {
    PURCHASE_ERROR = 'Process payment error',
    EDIT_PAYMENT_ERROR = 'Edit Payment Error',
    RESET_PWD_ERROR = 'Reset Password error',
    SIGN_UP_ERROR = 'Sign Up Error',
    LOGIN_FAIL = 'LoginFail',
    NO_AUTH_N = 'NoAuthN',
    NO_AUTH_Z = 'NoAuthZ',
    RECURLY = 'Recurly setup',
    APP_LOG_TEXT = 'The code is not valid. Please try again.',
    APP_LOG_ERROR_TYPE = 'authentication error',
}

enum SyncCommands {
    ADD = 'ADD',
    DELETE = 'DELETE',
    UPDATE = 'UPDATE',
}

enum USER_TYPE {
    ANONYMOUS = 'ANONYMOUS',
}

enum USER_LOGIN_TYPE {
    MVPD_AUTHSUITE = 'MVPD_AuthSuite',
    STANDARD = 'standard',
    MVPD = 'mvpd',
    RENDEZVOUS = 'rendezvous',
}

enum USER_STATUS {
    SB = 'sb|0',
}

enum LOG_TYPES {
    AUTHENTICATION = 'authentication error',
}

const CONTINUOUS_PLAY = 'continuous_play';

const ACTIONS = 'actions';
const PRESCRIBED_NAME = 'prescribedName';
const SELECT_PROFILE = 'select_profile';
const SELECT_AVATAR = 'select_avatar';

const SHOWPICKER_WATCHLIST_ENABLED = 'showpicker_watchlist_enabled';

const ON = 'on';
const OFF = 'off';

const MF_SET = 'mf_set';

const DATA_BUTTON = 'data-button';

const CUSTOM_TRACK = 'data-custom-track';

enum DATA_ATTRIBUTES_KEYS {
    AVATAR_FILE_NAME = 'data-avatar-file-name',
    AVATAR_GROUP_ID = 'data-avatar-group-id',
    AVATAR_GROUP_TITLE = 'data-avatar-group-title',
    AVATAR_UUID = 'data-avatar-uuid',
    CTA = 'data-cta-text',
    LINK_NAME = 'data-link-name',
    MENU_ITEM_LABEL = 'data-menu-item-label',
    MENU_ORIENTATION = 'data-menu-orientation',
    MENU_SLUG = 'data-menu-slug',
    PAGE_TITLE = 'data-page-title',
    PAGE_TYPE = 'data-page-type',
    PAGE_URL = 'data-page-url',
    PARTNER_BUNDLE = 'data-partner-bundle',
    PASS_IS_VISIBLE = 'data-pass-is-visible',
    POS_COL_NUM = 'data-pos-col-num',
    POS_ROW_NUM = 'data-pos-row-num',
    ROW_HEADER_POSITION = 'data-row-header-position',
    ROW_HEADER_TITLE = 'data-row-header-title',
    ROW_HEADER_NUMBER_TOTAL = 'data-row-header-number-total',
    SHOWPICKER_CONTENT_LIST = 'data-showpicker-content-list',
    SHOWPICKER_COUNT = 'data-showpicker-count',
    SHOWPICKER_GENRE_SELECTED = 'data-showpicker-genre-selected',
    SHOWPICKER_POS = 'data-showpicker-position',
    SHOWPICKER_SELECTION = 'data-showpicker-selection',
    UPSELL_TYPE = 'data-upsell-type',
    USE_LINK = 'data-use-link',
    USER_LOGIN_TYPE = 'data-user-login-type',
    USER_PROFILE_CATEGORY = 'data-user-profile-category',
    USER_PROFILE_ID = 'data-user-profile-id',
    USER_PROFILE_MASTER = 'data-user-profile-master',
    USER_PROFILE_PIC = 'data-user-profile-pic',
    USER_PROFILE_PIC_PATH = 'data-user-profile-pic-path',
    PICK_PLAN_SELECTION = 'data-pick-plan-selection',
    PICK_PLAN_TYPE = 'data-pick-plan-type',
    PICK_PLAN_SKU = 'data-pick-plan-sku',
    PURCHASE_PRODUCT_NAME = 'data-purchase-product-name',
    PRODUCT_NAME = 'data-product-name',
    PRODUCT_PRICING_PLAN = 'data-product-pricing-plan',
    PURCHASE_PRICE = 'data-purchase-price',
    PURCHASE_PROMO_CODE = 'data-purchase-promo-code',
    PRODUCT_DISCOUNT = 'data-product-discount',
    PRODUCT_OFFER_PERIOD = 'data-product-offer-period',
    PRODUCT_CURRENT_SKU = 'data-product-current-sku',
    PRODUCT_NEW_SKU = 'data-product-new-sku',
    PROMO_OFFER = 'data-promo-offer',
    LIVE_TV_CHANNEL = 'data-live-tv-channel',
    CHANNEL_BROWSE_CATEGORY = 'data-channel-browse-category',
    CHANNEL_ID = 'data-channel-id',
    CHANNEL_SLUG = 'data-channel-slug',
    CURRENT_LISTING_TITLE = 'data-current-listing-title',
    MOVIE_ID = 'data-movie-id',
    MOVIE_TITLE = 'data-movie-title',
    SHOW_SERIES_ID = 'data-show-series-id',
    SHOW_SERIES_TITLE = 'data-show-series-title',
    PRESCRIBED_NAME = 'data-prescribed-name',
    PREVENT_AUTO_TRACKING = 'data-prevent-auto-tracking',
    CONTENT_LOCKED = 'data-content-locked',
    MOVIE_BROWSE_CATEGORY = 'data-movie-browse-category',
    MOVIE_GENRE = 'data-movie-genre',
    MOVIE_SERIES_ID = 'data-movie-series-id',
    MOVIE_SERIES_TITLE = 'data-movie-series-title',
    RESUME_RESTART_IS_PRESENT = 'data-resume-restart-is-present',
    SCREEN_NAME = 'data-screen-name',
    SHOW_BROWSE_CATEGORY = 'data-show-browse-category',
    SHOW_EPISODE_ID = 'data-show-episode-id',
    SHOW_EPISODE_NUMBER = 'data-show-episode-number',
    SHOW_EPISODE_TITLE = 'data-show-episode-title',
    SHOW_GENRE = 'data-show-genre',
    SHOW_SEASON_NUMBER = 'data-show-season-number',
    SHOW_SECTION_TITLE = 'data-show-section-title',
    SPLICE_ENABLED = 'data-splice-enabled',
    TRACKING_TYPE = 'data-type',
    TEST_ID = 'data-testid',
    SWITCH_PLAN_CLICK = 'data-switch-plan-click',
    IS_KIDS_CONTENT = 'data-is-kids-content',
}

export type DataTrackingProps = {
    [DATA_ATTRIBUTES_KEYS.AVATAR_FILE_NAME]?: string;
    [DATA_ATTRIBUTES_KEYS.AVATAR_GROUP_ID]?: string;
    [DATA_ATTRIBUTES_KEYS.AVATAR_GROUP_TITLE]?: string;
    [DATA_ATTRIBUTES_KEYS.AVATAR_UUID]?: string;
    [DATA_ATTRIBUTES_KEYS.CTA]?: string;
    [DATA_ATTRIBUTES_KEYS.LINK_NAME]?: string;
    [DATA_ATTRIBUTES_KEYS.MENU_ITEM_LABEL]?: string;
    [DATA_ATTRIBUTES_KEYS.MENU_SLUG]?: string;
    [DATA_ATTRIBUTES_KEYS.PAGE_TITLE]?: string;
    [DATA_ATTRIBUTES_KEYS.PAGE_TYPE]?: string;
    [DATA_ATTRIBUTES_KEYS.PAGE_URL]?: string;
    [DATA_ATTRIBUTES_KEYS.PARTNER_BUNDLE]?: string;
    [DATA_ATTRIBUTES_KEYS.PASS_IS_VISIBLE]?: string;
    [DATA_ATTRIBUTES_KEYS.POS_COL_NUM]?: string;
    [DATA_ATTRIBUTES_KEYS.POS_ROW_NUM]?: string;
    [DATA_ATTRIBUTES_KEYS.ROW_HEADER_POSITION]?: string;
    [DATA_ATTRIBUTES_KEYS.ROW_HEADER_TITLE]?: string;
    [DATA_ATTRIBUTES_KEYS.ROW_HEADER_NUMBER_TOTAL]?: string;
    [DATA_ATTRIBUTES_KEYS.SHOWPICKER_CONTENT_LIST]?: string;
    [DATA_ATTRIBUTES_KEYS.SHOWPICKER_COUNT]?: string;
    [DATA_ATTRIBUTES_KEYS.SHOWPICKER_GENRE_SELECTED]?: string;
    [DATA_ATTRIBUTES_KEYS.SHOWPICKER_POS]?: string;
    [DATA_ATTRIBUTES_KEYS.SHOWPICKER_SELECTION]?: string;
    [DATA_ATTRIBUTES_KEYS.UPSELL_TYPE]?: string;
    [DATA_ATTRIBUTES_KEYS.USER_LOGIN_TYPE]?: USER_LOGIN_TYPE;
    [DATA_ATTRIBUTES_KEYS.USER_PROFILE_CATEGORY]?: string;
    [DATA_ATTRIBUTES_KEYS.USER_PROFILE_ID]?: string;
    [DATA_ATTRIBUTES_KEYS.USER_PROFILE_MASTER]?: string;
    [DATA_ATTRIBUTES_KEYS.USER_PROFILE_PIC]?: string;
    [DATA_ATTRIBUTES_KEYS.USER_PROFILE_PIC_PATH]?: string;
    [DATA_ATTRIBUTES_KEYS.PICK_PLAN_SELECTION]?: string;
    [DATA_ATTRIBUTES_KEYS.PICK_PLAN_TYPE]?: string;
    [DATA_ATTRIBUTES_KEYS.PICK_PLAN_SKU]?: string;
    [DATA_ATTRIBUTES_KEYS.PRODUCT_NAME]?: string;
    [DATA_ATTRIBUTES_KEYS.PURCHASE_PRODUCT_NAME]?: string;
    [DATA_ATTRIBUTES_KEYS.PRODUCT_PRICING_PLAN]?: string;
    [DATA_ATTRIBUTES_KEYS.PURCHASE_PRICE]?: number;
    [DATA_ATTRIBUTES_KEYS.PURCHASE_PROMO_CODE]?: string;
    [DATA_ATTRIBUTES_KEYS.PRODUCT_DISCOUNT]?: string;
    [DATA_ATTRIBUTES_KEYS.PRODUCT_OFFER_PERIOD]?: string;
    [DATA_ATTRIBUTES_KEYS.PROMO_OFFER]?: string;
    [DATA_ATTRIBUTES_KEYS.LIVE_TV_CHANNEL]?: string;
    [DATA_ATTRIBUTES_KEYS.CHANNEL_BROWSE_CATEGORY]?: string;
    [DATA_ATTRIBUTES_KEYS.CHANNEL_ID]?: string;
    [DATA_ATTRIBUTES_KEYS.CHANNEL_SLUG]?: string;
    [DATA_ATTRIBUTES_KEYS.CURRENT_LISTING_TITLE]?: string;
    [DATA_ATTRIBUTES_KEYS.PRESCRIBED_NAME]?: string;
    [DATA_ATTRIBUTES_KEYS.CONTENT_LOCKED]?: string;
    [DATA_ATTRIBUTES_KEYS.MOVIE_BROWSE_CATEGORY]?: string;
    [DATA_ATTRIBUTES_KEYS.MOVIE_GENRE]?: string;
    [DATA_ATTRIBUTES_KEYS.MOVIE_ID]?: string;
    [DATA_ATTRIBUTES_KEYS.MOVIE_SERIES_ID]?: string;
    [DATA_ATTRIBUTES_KEYS.MOVIE_SERIES_TITLE]?: string;
    [DATA_ATTRIBUTES_KEYS.MOVIE_TITLE]?: string;
    [DATA_ATTRIBUTES_KEYS.RESUME_RESTART_IS_PRESENT]?: string;
    [DATA_ATTRIBUTES_KEYS.SCREEN_NAME]?: string;
    [DATA_ATTRIBUTES_KEYS.SHOW_BROWSE_CATEGORY]?: string;
    [DATA_ATTRIBUTES_KEYS.SHOW_EPISODE_ID]?: string;
    [DATA_ATTRIBUTES_KEYS.SHOW_EPISODE_NUMBER]?: string;
    [DATA_ATTRIBUTES_KEYS.SHOW_EPISODE_TITLE]?: string;
    [DATA_ATTRIBUTES_KEYS.SHOW_GENRE]?: string;
    [DATA_ATTRIBUTES_KEYS.SHOW_SEASON_NUMBER]?: string;
    [DATA_ATTRIBUTES_KEYS.SHOW_SECTION_TITLE]?: string;
    [DATA_ATTRIBUTES_KEYS.SHOW_SERIES_ID]?: string;
    [DATA_ATTRIBUTES_KEYS.SHOW_SERIES_TITLE]?: string;
    [DATA_ATTRIBUTES_KEYS.SPLICE_ENABLED]?: string;
    [DATA_ATTRIBUTES_KEYS.TRACKING_TYPE]?: string;
    [DATA_ATTRIBUTES_KEYS.IS_KIDS_CONTENT]?: string | boolean;
};
const REGISTER_MF = 'registerMFs';

const SWITCH_CLASS = ['vds-switch'];
const TOGGLE_CLASS = ['vds-toggle'];

enum ELEMENT_TYPES {
    BUTTON = 'button',
    TOGGLE = 'toggle',
    SWITCH = 'switch',
    LINK = 'link',
}

const LINK_NODE = 'a';

const REFERRAL_SOURCES: Record<string, string> = {
    google: 'google-organic',
    bing: 'bing-organic',
    yahoo: 'yahoo-organic',
    duckduckgo: 'duckduckgo-organic',
    baidu: 'baidu-organic',
    yandex: 'yandex-organic',
    ecosia: 'ecosia-organic',
    facebook: 'organic-social',
    instagram: 'organic-social',
    twitter: 'organic-social',
    'x.com': 'organic-social',
    't.co': 'organic-social',
};

const QUERY_PARAM_MAP: Record<string, string> = {
    utm_source: 'utmSource',
    utm_medium: 'utmMedium',
    utm_campaign: 'utmCampaign',
    utm_content: 'utmContent',
    utm_term: 'utmTerm',
    ftag: 'ftag',
    // Kochava campaign.  Also available as window.kochava.utm if the SDK is loaded.
    // But, the URL does NOT contain ANY campaign or other info required by tracking
    ko_click_id: 'kochavaClickId',
    partner_campaign_id: 'kochavaCampaignId',
};

export {
    ACTIONS,
    APP_LOG_TYPE,
    CONTINUOUS_PLAY,
    CUSTOM_TRACK,
    DATA_ATTRIBUTES_KEYS,
    DATA_BUTTON,
    DATA_TAG,
    DIRECT,
    ELEMENT_TYPES,
    ERROR,
    EVENT,
    FOOTER,
    LINK_NODE,
    LOG_TYPES,
    MF_SET,
    NAV,
    OFF,
    ON,
    PAGE_TYPES,
    PAGE_UPDATE,
    PAID_SEARCH,
    PRESCRIBED_NAME,
    PROGRAMMATIC,
    QUERY_PARAM_MAP,
    REFERRAL_SOURCES,
    REGISTER_MF,
    ROUTE_CHANGE_COMPLETE,
    ROUTE_CHANGE_ERROR,
    ROUTE_CHANGE_START,
    SANDBOX,
    SELECT_AVATAR,
    SELECT_PROFILE,
    SHOWPICKER_WATCHLIST_ENABLED,
    SWITCH_CLASS,
    SyncCommands,
    TOGGLE_CLASS,
    UPDATE_DATA_LAYER,
    USER_LOGIN_TYPE,
    USER_STATUS,
    USER_TYPE,
};
